import { useState } from "react";
import { Table } from "react-bootstrap";
import { useHistory } from "react-router";
import { useAccount } from "../Context/AccountProvider";
import { getAllSettings, updateSetting } from "../LogicModules/SettingsAPI";
import { getToken } from "../LogicModules/TokenAPI";
import AuthenticationError from "../Modules/AuthenticationError";

export function StaffSettingsPage() {
  const [settingsLoaded, setSettingsLoaded] = useState(false);
  const [settings, setSettings] = useState();
  
  async function loadSettings() {
    let data = await getAllSettings();
    setSettingsLoaded(true);
    setSettings(data.result);
  }

  const { accountInfo } = useAccount();
  let history = useHistory(); 
  const redirectHome = () =>{ history.push("/") }

  if (accountInfo.loggedIn) {
    if (!accountInfo.user.ServerStaff) {
      redirectHome();
    }

    if (!settingsLoaded) {
      loadSettings();
    }

    if (settings) {
      return (
        <div className="white center">
          <Table striped bordered variant="light">
            <thead>
              <tr>
                <th style={{width: "20%"}}>Setting</th>
                <th>Value</th>
              </tr>
            </thead>
            <tbody>          
              {renderSettings(settings)}
            </tbody>
          </Table>
          <div style={{textAlign: "right"}}>
            <button type="button" onClick={() => {saveSettings()}}>Save Settings</button>
          </div>
        </div>
      );
    } else {
      return (
        <div className="white center">
          Loading settings...
        </div>
      );
    }
  } else if (getToken() != null) {
    return (
      <></>
    )
  } else {
    return (
      <AuthenticationError />
    )
  }
}


async function saveSettings() {
  let settingsToSave = document.getElementsByClassName("setting-update");

  let settingCount = settingsToSave.length;
  let successCount = 0;

  for (let settingElement of settingsToSave) {
    let settingSaved = await updateSetting(settingElement.name, settingElement.value);

    if (settingSaved === "ok") {
      successCount++;
    }
    
  }

  if (settingCount === successCount) {
    alert("Settings saved successfully!")
  } else {
    alert("There was an error saving some of your settings!");
  }
}

function renderSettings(data) {
  let responseArray = [];
  
  for (let setting of data) {
    responseArray.push(
      <tr>
        <td>{setting["key"]}</td>
        <td><input className="setting-update" name={setting["key"]} type="text" defaultValue={setting["value"]} style={{width: "100%"}}/></td>
      </tr>
    )
  }
  

  return responseArray;
}